import { staticTable } from "@-/dev.improve.haniverse.database.schemas.static._lib.table";
import { index, integer } from "@-/dev.improve.haniverse.lib.database.table";
import { graphemeTable } from "@-/dev.improve.haniverse.database.schemas.static.schema._tables.grapheme";

/**
 * Ordered occurrences in each learning card's effective decomposition. Repeated components have
 * repeated rows; ordering is the row-id order assigned by the static assembler.
 */
export const graphemeComponentTable = staticTable(
  "grapheme_component",
  {
    componentGraphemeId: integer("component_grapheme_id")
      .notNull()
      .references(() => graphemeTable.id),
    graphemeId: integer("grapheme_id")
      .notNull()
      .references(() => graphemeTable.id),
  },
  (table) => [
    index("grapheme_component_grapheme_id_idx").on(table.graphemeId),
    index("grapheme_component_component_grapheme_id_idx").on(table.componentGraphemeId),
  ],
);

export type GraphemeComponent = typeof graphemeComponentTable.$inferSelect;
